import { InProcessShipmentList } from './InProcessShipmentList'

export const InProcessPage = () => {
  return (
    <div className="shipper-page-fill shipper-grid-rows-single-fill grid overflow-hidden bg-[#f2f2f2] grid-cols-[19rem_1fr_30.5rem]">
      <InProcessShipmentList />
    </div>
  )
}
